import request from "../libs/request";
import { BuildingId } from "../types/building";

import { BuildingSpaceIdRequest } from "./buildingServices";
import {
  EquipmentStatus,
  HotColdAirInfo,
  VentilationStatus,
} from "./hotColdVoteServices";

const baseUrl = `${process.env.REACT_APP_API_URL}/v2/manager/building`;

export type ManagerBuildingSpace = BuildingId & {
  sort?: string;
};

export const getManagerBuildingSpaceAir = (params: ManagerBuildingSpace) =>
  request.get<HotColdAirInfo>(`${baseUrl}/${params.buildingId}/space`, {
    params,
  });

export const getManagerBuildingSpace = (params: BuildingSpaceIdRequest) =>
  request.get(`${baseUrl}/space/${params.buildingSpaceId}`);

export type ManagerBuildingSensorRequest = {
  buildingSpaceIds: string[];
  equipmentStatus: EquipmentStatus;
  ventilationStatus: VentilationStatus;
};

export const patchManagerBuildingSpaceSensorStatus = (
  params: ManagerBuildingSensorRequest
) => request.patch(`${baseUrl}/space/sensor-status`, params);
